var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { attrs: { className: "sub-title" } }, [
      _vm._v("\n    获取浏览器基本信息示例\n  ")
    ]),
    _vm._v(" "),
    _vm.mobileInfo
      ? _c("div", [_vm._v("\n    " + _vm._s(_vm.mobileInfo) + "\n  ")])
      : _vm._e(),
    _vm._v(" "),
    _vm.mobileModel
      ? _c("div", [
          _c("div", { attrs: { className: "{styles.textLabel}" } }, [
            _vm._v("\n      系统: " + _vm._s(_vm.mobileModel.os) + "\n    ")
          ]),
          _vm._v(" "),
          _c("div", { attrs: { className: "{styles.textLabel}" } }, [
            _vm._v(
              "\n      系统的版本号: " +
                _vm._s(_vm.mobileModel.version) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("div", { attrs: { className: "{styles.textLabel}" } }, [
            _vm._v(
              "\n      设备型号: " + _vm._s(_vm.mobileModel.model) + "\n    "
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.md
      ? _c("div", [
          _c("div", { attrs: { className: "{styles.textLabel}" } }, [
            _vm._v(
              "\n      " +
                _vm._s("md.mobile() -> " + _vm.md.mobile()) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("div", { attrs: { className: "{styles.textLabel}" } }, [
            _vm._v(
              "\n      " + _vm._s("md.phone() -> " + _vm.md.phone()) + "\n    "
            )
          ]),
          _vm._v(" "),
          _c("div", { attrs: { className: "{styles.textLabel}" } }, [
            _vm._v(
              "\n      " +
                _vm._s("md.userAgent() -> " + _vm.md.userAgent()) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("div", { attrs: { className: "{styles.textLabel}" } }, [
            _vm._v("\n      " + _vm._s("md.os() -> " + _vm.md.os()) + "\n    ")
          ]),
          _vm._v(" "),
          _c("div", { attrs: { className: "{styles.textLabel}" } }, [
            _vm._v(
              "\n      " +
                _vm._s("md.version('Webkit') -> " + _vm.md.version("Webkit")) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("div", { attrs: { className: "{styles.textLabel}" } }, [
            _vm._v(
              "\n      " +
                _vm._s("md.maxPhoneWidth -> " + _vm.md.maxPhoneWidth) +
                "\n    "
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-469af010", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-469af010","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HelloWorld.vue
// module id = null
// module chunks = 